// extracted by mini-css-extract-plugin
export default {"tabsHeader":"OfflineInfoTabs_tabsHeader__XZ3CY","tabsContent":"OfflineInfoTabs_tabsContent__-Nlt4","tabContent":"OfflineInfoTabs_tabContent__B69QY"};